import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { computed, Injectable, Signal } from '@angular/core';
import { ServiceGroupObject } from '@libs/types/src/services/object-type/service/service-group.object';

@Injectable()
export class SelectFolderGroupsDialogStore extends ComponentStoreV2Factory {

    public groupOptions: Signal<ServiceGroupObject[]> = computed(() => {
        return this.data.getServiceGroups()?.['items'] || [];
    });

}
